import i18n from '@/lang'

export default function (to) {
  let title = 'Flight Dispatch'
  if (to.meta && to.meta.title) {
    title += ' | '
    if (typeof to.meta.title === 'function') {
      title += to.meta.title(to)
    } else if (('' + to.meta.title).startsWith('i18n:')) {
      title += i18n.global.t(('' + to.meta.title).substring(5))
    } else {
      title += to.meta.title
    }
  }
  document.title = title
}
